<template>
  <div class="row g-1 wrap">
    <FontAwesomeIcon v-for="icon in icons" :key="icon" :icon="iconMap[icon]" v-tooltip="$tc(`${id}:${icon}`)" />
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    item: Object,
    iconMap: {
      type: Object,
      defualt: () => ({}),
    },
    source: {
      type: String,
      defualt: '',
    },
  },

  computed: {
    icons() {
      const icons = this.$path(`${this.source}`, this.item)
      if (!icons) return []
      return icons.filter(icon => icon in this.iconMap)
    },
  },
}
</script>

<style lang="scss"></style>
